# Returns ``$url`` with ``/client/:clientId`` appended.
angular.module('rjmNg.services').factory '$clientUrl', [
  "$url"
  "appParams"
  (
    $url
    appParams
  ) ->
    (url) ->
      $url("/client/#{appParams.clientId}#{url}")

]
